export default __webpack_public_path__ + "static/media/download.05f2a942.svg";